import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/tokens/figma-page3.css';
import './index.css';
import './styles/tokens/legacy-aliases.css';
/*
 * 화면 코드는 지연 로드하되 전역 CSS는 기존 production 순서로 한 번에 고정한다.
 * 화면별 chunk가 CSS 순서를 바꾸거나 첫 진입 뒤 스타일을 덧씌우는 FOUC를 막는 계약이다.
 */
import './components/ui/primitives/choice-chip.css';
import './components/ui/primitives/form-primitives.css';
import './components/ui/primitives/common-composition-primitives.css';
import './components/ui/primitives/report-service-primitives.css';
import './components/report/report-welcome-final-freeze.css';
import './components/report/figma-report-final-freeze.css';
import './components/ui/primitives/action-primitives.css';
import './components/ui/primitives/bottom-action-bar.css';
import './components/wizard/phase5-wizard-canary.css';
import './components/ui/primitives/auth-service-primitives.css';
import './components/login-final-freeze.css';
import './components/ui/primitives/admin-onboarding-common-primitives.css';
import './components/admin/admin-final-freeze.css';
import './components/member/phase6-member-final-freeze.css';
import './styles/pt-picker.css';
import './styles/prescription.css';
import './components/settings/figma-settings-freeze.css';
import './components/notifications/notifications-inbox.phase6.css';
import './components/phase5/phase5-operations-canary.css';
import './components/self/phase6-wavee-shared-checkin-final-freeze.css';
import './styles/home-queue.css';
import './styles/member-page.css';
import './styles/autonomous-workout.css';
import './components/self/phase6-self-final-freeze.css';
import './components/ui/primitives/meal-service-primitives.css';
import './components/self/phase5-meal-canaries.css';
import './components/ui/primitives/meal-daily-service-primitives.css';
import './components/ui/primitives/common-header.css';
import './components/ui/full-screen-action-guide.css';
import './components/self/phase6-wavef-remaining-overlays.css';
import './components/care/careTokens.css';
import './components/ui/primitives/overlay-sheet-primitives.css';
import './components/care/phase6-wavef-care-schedule.css';
import './components/care/phase5-overlay-canaries.css';
import './components/care/phase6-care-weekly-final-freeze.css';
import './components/ui/primitives/service-schedule-primitives.css';
import './components/onboarding/onboarding-final-freeze.css';
import './components/ui/primitives/pricing-service-primitives.css';
import './components/pricing/phase6-pricing-final-freeze.css';
import './components/layer365/layer365-entry.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
